import { Injectable, Inject } from '@angular/core';
import { DialogService } from './dialog.service';
import { FortNoxAuthService } from './fortnox-auth.service';

@Injectable({
  providedIn: 'root',
})
export class OauthUtilService {
  constructor(
    @Inject(DialogService) private dialogService: DialogService,
    @Inject(FortNoxAuthService) private fortNoxAuthService: FortNoxAuthService
  ) {}

  async oauthLoginHandler(error: any): Promise<void> {
    console.log('OauthUtilService.oauthLoginHandler called', error);
    const redirectUrl = `${error.error || error.message || ''}`.trim();
    const bodyText = redirectUrl || 'Okänt fel';
    const confirmed = await this.dialogService.confirm({
      title: 'Det krävs en ny inloggning till Fortnox',
      body: bodyText,
      confirmText: 'Logga in',
      cancelText: 'Avbryt',
    });

    if (!confirmed) {
      return;
    }

    if (!redirectUrl) {
      return;
    }

    console.log('Modal confirmed, redirecting to Fortnox:', redirectUrl);
    window.location.href = redirectUrl;
  }

  fullUrl(): string {
    const location = window.location;
    return `${location.protocol}//${location.host}${location.pathname}`;
  }

  getAccessToken(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const accessCode = urlParams.get('code');
    const state = urlParams.get('state');

    if (accessCode) {
      console.log('URL parameter accessKod:', accessCode);
      console.log('URL parameter state:', state);

      this.fortNoxAuthService
        .save(
          {},
          {
            access_code: accessCode,
            redirect_uri: this.fullUrl(),
            state: state,
          }
        )
        .subscribe({
          next: (success) => {
            console.log('FortNoxAuth success', success);
            // Remove all query parameters from the URL
            const url = new URL(window.location.href);
            url.search = '';
            history.replaceState(null, '', url.toString());
            // Nothing to do — we're back in the same tab after Fortnox redirect
          },
          error: (error) => {
            console.log('FortNoxAuth error', error);
          },
        });
    } else {
      console.log('No URL parameter accessKod');
    }
  }
}
